import { AmplitudeFlagKey } from "@simplyk/common";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useAmplitudeFeatureFlag } from "@/common/hooks/amplitude/useAmplitudeFeatureFlag";

export const useCommunicationPreferencesFlag = () => {
  const { organization } = useCurrentUserContext();

  return useAmplitudeFeatureFlag({
    flagKey: AmplitudeFlagKey.CommunicationPreferences,
    organizationId: organization?.id,
    userProperties: { organizationId: organization?.id || "" },
    skip: !organization?.id,
  });
};
